import { application } from "../helpers/stimulus"

import CarouselController from "../controllers/carousel_controller"
import ClearableInputController from "../controllers/clearable_input_controller"
import ComboboxController from "../controllers/combobox_controller"
import CounterController from "../controllers/counter_controller"
import DialogController from "../controllers/dialog_controller"
import DrawerController from "../controllers/drawer_controller"
import DrawerGroupController from "../controllers/drawer_group_controller"
import LoaderController from "../controllers/loader_controller"
import ModalController from "@/controllers/modal_controller"
import ModalTriggerController from "../controllers/modal_trigger_controller"
import TabsController from "../controllers/tabs_controller"

import SearchBarController from "../controllers/search/search_bar_controller"
import SearchDateController from "../controllers/search/search_date_controller"
import SearchExperienceController from "../controllers/search/search_experience_controller"
import SearchGuestsController from "../controllers/search/search_guests_controller"
import SearchLocationController from "../controllers/search/search_location_controller"
import SearchModalController from "../controllers/search/search_modal_controller"

import { fetchRecentLocations } from "@/helpers/recent_locations"

const setupSearchBar = (): void => {
  application.register("carousel", CarouselController)
  application.register("clearable-input", ClearableInputController)
  application.register("combobox", ComboboxController)
  application.register("dialog", DialogController)
  application.register("drawer", DrawerController)
  application.register("drawer-group", DrawerGroupController)
  application.register("geolocation-modal", ModalController)
  application.register("guests-counter", CounterController)
  application.register("loader", LoaderController)
  application.register("page-loader", LoaderController)
  application.register("search-bar", SearchBarController)
  application.register("search-date", SearchDateController)
  application.register("search-experience", SearchExperienceController)
  application.register("search-guests", SearchGuestsController)
  application.register("search-location", SearchLocationController)
  application.register("search-modal", SearchModalController)
  application.register("search-modal-trigger", ModalTriggerController)
  application.register("tabs", TabsController)

  // We do this in the component rather than in location controller's `#initialize` because we have
  // two instances (bar and modal) which means it would run twice.
  fetchRecentLocations()
}

export { setupSearchBar }
